import axios from 'axios';
// import jwt from 'jsonwebtoken';

const {
  VUE_APP_API_URL,
  VUE_APP_API_CHECKOUT,
  VUE_APP_API_NODE,
} = process.env;

const checkoutUrl = VUE_APP_API_CHECKOUT;
const nodeUrl = VUE_APP_API_NODE;
axios.defaults.baseURL = VUE_APP_API_URL;

// const signToken = payload => jwt.sign(payload, 'jnputin');

class Api {
  constructor() {
    this.axios = axios;
    this.checkoutUrl = checkoutUrl;
    this.nodeUrl = nodeUrl;
  }

  async login(payload) {
    const { data } = await this.axios.post('/auth/login', payload);
    return data;
  }

  async register(payload) {
    const { data } = await this.axios.post('/auth/signup', payload);
    return data;
  }

  async getDataEvent(eventId) {
    const { data } = await this.axios.get(`/PE/events/${eventId}`);
    if (!data.status) return false;
    return data.data;
  }

  async getSeatsStringByBlockId(payload) {
    // const payload = {
    //   typesAvailable: this.typesIds,
    //   venueId: this.eventData.idVenue,
    //   activityId: this.eventData.activity_id,
    //   dateHourId: this.currentType.adhId,
    //   blockId: this.svgBlock.id,
    // };
    const { data: { data } } = await this.axios.post('/theater/event-seats-block', payload);
    return data;
  }

  async getSeatsBuyed(payload) {
    // const payload = {
    //   activityId: this.eventData.activity_id,
    //   dateHourId: this.currentType.adhId,
    // };
    const { data: { data } } = await this.axios.post('/theater/event-seats-busy', payload);
    return data;
  }

  async seatVerifyAndReserved(payload) {
    // const payload = {
    //   activityId: this.eventData.activity_id,
    //   dateHourId: this.currentType.adhId,
    //   typesAvailable: this.typesIds,
    //   seat: data.id,
    //   reserveSeat: 1,
    //   reserveSeatAnnulled: 1,
    //   reserveSeatToken: reserveToken,
    // };
    const { data: { data } } = await this.axios.post('/theater/event-seat-valid', payload);
    return data;
  }

  async solicitRepayment(payload) {
    const data = await this.axios.post('/refunds/store-clients-data', payload);
    return data;
  }

  async getInfoRepayment(ticketId) {
    const { data } = await this.axios.get(`/refunds/available?ticketId=${ticketId}`);
    return data;
  }
}

export default new Api();
